import React from 'react'
import { Icon } from './GenericForm.elements'

type Props = {
  className?: string
}

export const GenericFormIcon = ({ className }: Props) => (
  <Icon
    viewBox="0 0 24 24"
    aria-hidden
    focusable={false}
    role="img"
    className={className}
    fill="none"
  >
    <rect x="3" y="3" width="18" height="18" rx="2" stroke="#173A68" strokeWidth="2"/>
    <path d="M7 14h10M7 17h7M9 8l2 2 4-4" stroke="#173A68" strokeWidth="2"/>
  </Icon>
)
